import React, { useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { Actions as EMPLOYEEACTIONS } from "../../../../store/actions/employeeActions";
import "react-datepicker/dist/react-datepicker.css";
import { format, addMonths } from "date-fns";
import { ArrowDownTrayIcon, ArrowUpTrayIcon, XMarkIcon } from "@heroicons/react/20/solid";
import ImportEmployeeRow from "./ImportEmployeeRow";
import { CSVLink } from "react-csv";
import Spinner from "../../../common/Spinner";
import ImportedEmployeeRow from "./ImportedEmployeeRow";
import { FileUploader } from "react-drag-drop-files";
import { Cog8ToothIcon, DocumentArrowUpIcon } from "@/icons/solid";
import Tooltip from "@/tooltip";
import BuddySelector from "buddy/selector";
import ImportFieldMapper from "./ImportFieldMapper";

const importTypes = [
	{
		label: "Buddy Format",
		// value: "Buddy",
	},
	{
		label: "Employee Details (Any Excel/CSV)",
		value: "Other",
	},
	{
		label: "Totals To Date",
		value: "TotalsToDate",
	},
	{
		label: "Recurring Pay Items",
		value: "PayItems",
	},
	/*{
		label: "Shireburn Indigo Format",
		value: "Indigo",
		country: ["MT"],
	},
	{
		label: "Talexio Format",
		value: "Talexio",
		country: ["MT"],
	},*/
];

const ModuleStage = ({
	importStage,
	uploadTemplate,
	setImportType,
	importType,
	replaceExisting,
	setReplaceExisting,
	filesUploaded,
	processUploadFile,
	mapUploadFields,
	uploading,
	uploadResults,
	closeModal,
	countryTypes,
	hideSaved,
	setHideSaved,
    modalStatus,
    setFile,
    errors,
}) => {

	const ImportSelection = <>
			<div className="relative flex py-5 items-center">
				<strong
					className="uppercase"
					style={{ color: "rgb(211, 211, 211)" }}
				>
					Import
				</strong>
				<div class="grow border-t ml-4"></div>
			</div>
			{modalStatus === "Excel Import" && (
				<>
					<div className="col-xs-6">
						<label htmlFor="material-text">Choose your data format below.</label>
						<BuddySelector
							value={countryTypes.find(({ value }) => value === importType)}
							options={countryTypes}
							isDisabled={countryTypes?.length === 1 || uploading}
							onChange={(selected) => setImportType(selected?.value)}
							placeholder="Import Format"
						/>
					</div>
					<div
						className="col-xs-6"
						style={{ marginTop: "2.7rem" }}
					>
						<label
							forHTML="replaceExisting"
							className="css-input switch switch-sm switch-success inline"
							onClick={() => {
								if (uploading) return;
								setReplaceExisting(!replaceExisting);
							}}
						>
							<input
								id="replaceExisting"
								name="mode"
								type="checkbox"
								disabled={uploading}
								checked={replaceExisting}
							/>
							<span style={{pointerEvents: "none"}}></span>
							Replace employee details if found
						</label>
					</div>
				</>
			)}
			<div
				className="col-xs-12"
				style={{ marginTop: "2rem" }}
			>
				{
					["PayItems","Other","TotalsToDate"].includes(importType) && (
						<>
							<button
								className="btn btn-success pull-right"
								onClick={mapUploadFields}
							>
								<ArrowUpTrayIcon className="h-8 align-middle mr-2" />
								Verify Field Mapping
							</button>
						</>
					)
				}
				{!["PayItems","Other","TotalsToDate"].includes(importType) && filesUploaded?.length > 0 ? (
					<>
						<button
							className="btn btn-success pull-right"
							onClick={processUploadFile}
							disabled={uploading}
						>
							<ArrowUpTrayIcon className="h-8 align-middle mr-2" />
							{uploading ? "Importing..." : `Import Employees`}
						</button>
					</>
				) : null}
			</div>
		</>


	switch (importStage) {
		case "Download":
			return (
				<div
					className="flex items-center mb-5"
					style={{
						flexDirection: "column",
						justifyContent: "space-between",
					}}
				>
					<div className="mt-4">
						{uploadTemplate ? (
							<div className="btn-group">
								<a
									className="btn btn-default pull-right"
									target="_blank"
									href={uploadTemplate}
								>
									<ArrowDownTrayIcon className="mr-2 h-7 w-7 align-middle" />
									Excel Template
								</a>
								<button
									className="btn btn-default px-2"
									disabled
								>
									<Tooltip content="Configure Template: Coming Soon">
										<Cog8ToothIcon className="h-7 w-7 align-middle" />
									</Tooltip>
								</button>
							</div>
						) : (
							<div
								className="btn btn-default"
								disabled
							>
								<Spinner className="animate-spin -ml-1 mr-3 h-5 w-5 align-middle" />
								Loading Template
							</div>
						)}
					</div>
				</div>
			);
		case "Import":
			return (ImportSelection);
		case "Review v2":
			const processedEmployees =
				uploadResults?.processed?.filter(({ saved }) => (hideSaved ? !saved : true)) || [];
			const processedErrors = processedEmployees?.reduce((prev, curr) => {
				return prev.concat(curr?.errors.map((item) => [curr.reference, String(curr.rowNumber), item]) || []);
			}, []);
			return (
				<>
					<div className="col-xs-12 form-section">
						<div className="col-xs-4 section-header">
							<h1>Import Results</h1>
						</div>
						<div className="col-xs-4 section-header">
							<div className="form-material">
								<label className="css-input switch switch-sm switch-success">
									<input
										id="hideSaved"
										name="hideSaved"
										checked={hideSaved}
										onClick={() => setHideSaved(!hideSaved)}
										onChange={(e) => {}} //To Prevent Error Spamming in Console
										type="checkbox"
									/>
									<span></span>
									<label
										style={{ marginBottom: 0 }}
										htmlFor="hideSaved"
									>
										Hide Saved Employees
									</label>
								</label>
							</div>
						</div>
						<div
							className="col-xs-4"
							style={{ textAlign: "right" }}
						>
							<h6>Saved: {uploadResults?.processed?.filter(({ saved }) => !!saved)?.length}</h6>
							<h6>Not Saved: {uploadResults?.processed?.filter(({ saved }) => !saved)?.length}</h6>
						</div>
						<div className="clearfix" />
						<div className="form-inner-section pr-0 pl-0">
							<div
								style={{
									display: "grid",
									gridGap: "1.5rem",
									grid: "1.5rem",
									gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
									padding: "1rem",
									borderBottom: "solid rgb(244,244,244) 4px",
								}}
							>
								<div style={{ gridColumn: "span 1 / span 5", textAlign: "center", opacity: "0.75" }}>
									<h5>Reference</h5>
								</div>
								<div style={{ gridColumn: "span 1 / span 5", textAlign: "center", opacity: "0.75" }}>
									<h5>Row</h5>
								</div>
								<div style={{ gridColumn: "span 1 / span 5", textAlign: "center", opacity: "0.75" }}>
									<h5>Errors</h5>
								</div>
								<div style={{ gridColumn: "span 1 / span 5", textAlign: "center", opacity: "0.75" }}>
									<h5>Saved</h5>
								</div>
							</div>
							{processedEmployees?.map(({ reference, rowNumber, errors, saved }, index) => {
								const isLast = index + 1 === processedEmployees.length;
								return (
									<ImportedEmployeeRow
										{...{ reference, rowNumber, errors, saved, isLast, hideSaved }}
									/>
								);
							})}
						</div>
					</div>
					<button
						className="btn btn-default pull-right"
						onClick={() => {
							closeModal();
							setFile(null);
						}}
						style={{ marginBottom: 20 }}
					>
						Close
					</button>
					{processedErrors ? (
						<CSVLink
							filename="Employee Import Errors.csv"
							className="btn btn-default pull-left"
							style={{ marginBottom: 20 }}
							data={[["Reference", "Row", "Error"], ...processedErrors]}
						>
							<ArrowDownTrayIcon
								className="w-6 h-6 mr-3"
								style={{ verticalAlign: "text-bottom" }}
							/>
							Download Error Report
						</CSVLink>
					) : null}
				</>
			);
		case "Map Fields":
		return <>
			{ImportSelection}
			<ImportFieldMapper importType={importType}/>
			{filesUploaded?.length > 0 ? (
				<>
					<button
						className="btn btn-success pull-right"
						onClick={processUploadFile}
						disabled={uploading}
					>
						<ArrowUpTrayIcon className="h-8 align-middle mr-2" />
						{uploading ? "Importing..." : `Import Employees`}
					</button>
				</>
			) : null}
		</>

	}
};

const ImportEmployeeModal = ({
	modalStatus,
	closeModal,
	uploadTemplate,
	uploadMapping,
	uploadResults,
	filesUploaded,
	getEmployeeTemplate,
	uploadEmployees,
	mapEmployeeUpload,
	uploadFile,
	uploading,
	employeesGetListWithSalary,
	jurisdiction,
	clearImportResults,
}) => {
	const [file, setFile] = useState(false);
	const [importType, setImportType] = useState();
	const [replaceExisting, setReplaceExisting] = useState(false);
	const [errors, setErrors] = useState([["Row", "Type", "Message"]]);
	const [hideSaved, setHideSaved] = useState(true);

	const countryTypes = useMemo(() => {
		return importTypes.filter(({ country }) => (country ? country.includes(jurisdiction) : true));
	}, [jurisdiction]);

	useEffect(() => {
		if (modalStatus === "Excel Import") getEmployeeTemplate();
	}, [modalStatus]);

	useEffect(() => {
		if (file && uploadResults) {
			setFile(null);
			employeesGetListWithSalary();
		}
		if (uploadResults?.errors || uploadResults?.warnings) {
			let newErrors = [["Row", "Type", "Message"]];
			uploadResults.processed
				.filter((i) => i.error || i.warnings)
				.map((item) => {
					if (item.error) {
						newErrors.push([item.rowNumber, "Error", item.error.message]);
					} else if (item.warnings) {
						item.warnings.map((i) => {
							newErrors.push([item.rowNumber, "Warning", i.message]);
						});
					}
				});
			setErrors(newErrors);
		}
	}, [JSON.stringify(uploadResults)]);

	const [width, importStage] = useMemo(() => {
		if (uploadResults && importType) return["75%" ,"Review v1"];
		if (uploadResults) return["75%" ,"Review v2"];
		if (uploadMapping) return["75%" ,"Map Fields"];
		if (file) return["75%" ,"Import"];
		if (modalStatus === "FPS XML Upload") return["40%" ,"Upload"];
		if (modalStatus === "Excel Import") return["40%" ,"Download"];
		return []
	}, [modalStatus, file, uploadResults, importType, uploadMapping]);

	const [message, files, fileName] = useMemo(() => {
		switch (modalStatus) {
			case "FPS XML Upload": {
				return [
					<>
						If you're already got your FPS XML file ready, upload it below. Employees will be mapped and
						their totals & other details will be updated and/or replaced according to the XML you've
						uploaded.
					</>,
					["xml"],
					"FPS XML File",
				];
			}
			default:
				return [
					<>
						If you're already got all your Employee's details in one place, fret not.
						<br />
						Just download our ready-made spreadsheet template, paste in the data, and upload it back when
						you're done.
					</>,
					["xlsx", "xls"],
					"Excel File",
				];
		}
	}, [modalStatus]);

	const selectUploadFile = (e) => {
		const file = e; // accessing file
		// console.log('file', file);
		setFile(file); // storing file
		if (uploadResults) clearImportResults();
		uploadFile(file);
	};

	const processUploadFile = () => {
		const options = {
			file,
			replaceExisting,
			importType: importType,
		};

		uploadEmployees(options);
	};

	const mapUploadFields = () => {
		const options = {
			file,
			replaceExisting,
			importType: importType,
		};

		mapEmployeeUpload(options);
	};

	if (!modalStatus) return null;

	return (
		<div
			className="modal"
			tabindex="-1"
			role="dialog"
			aria-hidden="true"
			style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "scroll" }}
		>
			<div
				className="modal-dialog"
				style={{ width }}
			>
				<div className="modal-content">
					<div
						className="block block-themed block-transparent remove-margin-b"
						style={{ padding: 0 }}
					>
						<div
							className="block-header bg-primary-dark"
							style={{ padding: 20 }}
						>
							<ul className="block-options">
								<li>
									<button
										type="button"
										onClick={() => {
											closeModal();
											setFile(null);
										}}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
							<h3 className="block-title">
								Import Employees via {modalStatus.replace("Import", "").replace("Upload", "")}
							</h3>
						</div>
						<div className="block-content p-8">
							{message}

							<div
								className="flex items-center mt-5"
								style={{
									flexDirection: "column",
									justifyContent: "space-between",
								}}
							>
								<FileUploader
									handleChange={selectUploadFile}
									name="file"
									disabled={uploading}
									children={
										<div className="upload-company-logo">
											<DocumentArrowUpIcon className="h-14" />
											{file?.name ? file?.name : `Upload or Drop ${fileName}`}
										</div>
									}
									types={files}
								/>
							</div>
							<ModuleStage
								importStage={importStage}
								uploadTemplate={uploadTemplate}
								setImportType={setImportType}
								importType={importType}
								replaceExisting={replaceExisting}
								setReplaceExisting={setReplaceExisting}
								filesUploaded={filesUploaded}
								processUploadFile={processUploadFile}
								mapUploadFields={mapUploadFields}
								uploading={uploading}
								uploadResults={uploadResults}
								closeModal={closeModal}
								countryTypes={countryTypes}
								hideSaved={hideSaved}
								setHideSaved={setHideSaved}
                                setFile={setFile}
                                errors={errors}
                                modalStatus={modalStatus}
							/>
							<div className="clearfix" />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const {
		importModal,
		uploadTemplate,
		uploadMapping,
		uploading,
		uploadResults,
		filesUploading,
		filesUploaded,
		importingEmployees: importing,
	} = state.employees;

	return {
		modalStatus: importModal,
		uploadTemplate,
		uploadMapping: uploadMapping ? true : false,
		uploading: uploading || importing,
		uploadResults,
		filesUploading,
		filesUploaded,
		jurisdiction: state.company?.settings?.jurisdiction,
	};
};

const mapDispatchToProps = (dispatch) => ({
	closeModal: () => dispatch(EMPLOYEEACTIONS.toggleImportModal()),
	getEmployeeTemplate: () => dispatch(EMPLOYEEACTIONS.getEmployeeTemplate()),
	mapEmployeeUpload: (input) => dispatch(EMPLOYEEACTIONS.mapEmployeeUpload(input)),
	uploadEmployees: (input) => dispatch(EMPLOYEEACTIONS.uploadEmployees(input)),
	clearImportResults: (input) => dispatch(EMPLOYEEACTIONS.clearImportResults(input)),
	uploadFile: (file, agreement) => dispatch(EMPLOYEEACTIONS.uploadFile({ file, agreement })),
	employeesGetListWithSalary: () =>
		dispatch(
			EMPLOYEEACTIONS.employeesGetListWithSalary({
				from: format(addMonths(new Date(), -2), "yyyy-MM-01"), // get list from last 2 months
				to: format(new Date(), "yyyy-12-31"),
			}),
		),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportEmployeeModal);
